import { AfterContentChecked, Component, ElementRef, EventEmitter, HostListener,
         Inject, Input, Output, ViewChild
       } from '@angular/core';

import { ColorPalette, ColorPaletteService } from './color-palette.service';

interface PhantomPalette {
  baseColors: Array<any>;
  additionalColors: Array<any>;
}

@Component({
  selector: 'color-chooser',
  templateUrl: './color-chooser.component.html',
  styleUrls: [ './color-chooser.component.scss' ],
})
export class ColorChooserComponent implements AfterContentChecked
{
  private static readonly ARROW_SIZE: number = 10; /* px */

  @ViewChild('root') private root: ElementRef;
  @ViewChild('wrapper') private wrapper: ElementRef;

  @Output() public currentColorChange: EventEmitter<string> =
      new EventEmitter();

  @Input() public currentColor: string = '#666';
  @Input() public palette: Array<string> = [];

  public colors: ColorPalette = {
    baseColors: [],
    additionalColors: [],
  };

  public phantoms: PhantomPalette = {
    baseColors: [],
    additionalColors: [],
  };
  private previousWrapperWidth: number = 0;

  public additionalColors: Array<string> = [];
  public showPalette: boolean = false;

  public paletteHeight: string = '0px';
  public paletteWidth: string = '0px';
  public paletteLeft: string = '0px';
  public arrowLeft: string = '0px';

  constructor(
      private element: ElementRef,
      @Inject(ColorPaletteService)
          public colorPaletteService: ColorPaletteService)
  { }

  public ngAfterContentChecked(): void
  {
    if (this.palette.length > 0) {
      this.colors.baseColors = this.palette;
    }
    else {
      this.colors.baseColors = this.colorPaletteService.colorPalette.baseColors;
      this.colors.additionalColors =
          this.colorPaletteService.colorPalette.additionalColors;
    }

    if (this.showPalette) {
      this.updatePhantomColors();
    }
  }

  public setColor(color: string): void
  {
    this.currentColor = color;
    this.showPalette = false;
    this.currentColorChange.emit(color);
  }

  @HostListener('document:click', ['$event'])
  public hideIfClickedOutside(event: Event): void
  {
    const clickedInside =
        this.element.nativeElement.contains(<HTMLElement> event.target);

    if (!clickedInside) {
      this.showPalette = false;
    }
  }

  @HostListener('window:resize')
  public adaptPaletteHeight(): void
  {
    if (!this.showPalette) {
      return;
    }

    const editor = <any>document.getElementsByClassName('editor')[0];
    const toolbar = <any>editor.getElementsByClassName('toolbar')[0];
    const root = this.root.nativeElement;

    const availableWidth = toolbar.offsetWidth;

    this.paletteWidth = availableWidth + 'px';
    this.paletteHeight = (toolbar.offsetTop + root.offsetTop) + 'px';
    this.paletteLeft = '-' + root.offsetLeft + 'px';
    this.arrowLeft =
      root.offsetLeft + root.offsetWidth / 2 - ColorChooserComponent.ARROW_SIZE
      + 'px';
  }

  private updatePhantomColors(): void
  {
    const wrapperWidth = this.wrapper.nativeElement.clientWidth;

    if (wrapperWidth < 1 || wrapperWidth === this.previousWrapperWidth) {
      return;
    }

    const getPhantomCount = (colors: Array<any>) => {
      const itemWidth = 28 + 10 + 2; // width + 2 * margin + 2 * border
      const itemsPerRow = Math.floor(wrapperWidth / itemWidth);
      return Array(itemsPerRow - (colors.length % itemsPerRow))
        .map(_ => undefined);
    };

    this.phantoms = {
      additionalColors: getPhantomCount(this.colors.additionalColors),
      baseColors: getPhantomCount(this.colors.baseColors)
    };

    this.previousWrapperWidth = wrapperWidth;
  }
}



// WEBPACK FOOTER //
// ./src/app/controls/color-chooser/color-chooser.component.ts